import React from "react";
import { Field, UseFieldConfig } from "react-final-form";
import FormFile, { FormFileProps } from "ui/Form/File";

type Props = FormFileProps & UseFieldConfig<string> & { changeLabel?: string };

const FileField: React.FC<Props> = ({
    labelProps,
    fieldGroupProps,
    fieldControlProps,
    inputProps,
    infoMessage,
    changeLabel,
    compact,
    ...fieldProps
}) => {
    return (
        <Field name={inputProps.name} {...fieldProps}>
            {({ input, meta }) => {
                return (
                    <FormFile
                        error={!!(meta.error || meta.submitError)}
                        errorMessage={meta.error || meta.submitError}
                        labelProps={labelProps}
                        fieldGroupProps={fieldGroupProps}
                        fieldControlProps={fieldControlProps}
                        inputProps={Object.assign({}, inputProps, input)}
                        infoMessage={infoMessage}
                        changeLabel={changeLabel}
                        compact={compact}
                    />
                );
            }}
        </Field>
    );
};

export default FileField;
